import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getAnalyticsColumns = async (token, params) => {
  const url = 'analytics_columns'
  const data = await apiGet({ url, params, token })
  return data
}

export function useAnalyticsColumns({ params = {}, options }) {
  const token = useContext(AuthContext)
  const queryFn = () => getAnalyticsColumns(token, params)
  const queryKey = ['analytics-columns', params]

  return useQuery(queryKey, queryFn, {
    ...options
  })
}